import Repository from "@/repositories/api.js"
const resource = "/admin/article_tags"

export default {
  async getAll() {
    let response = await Repository.get(resource)
    return response.data.article_tags
  }
}
